// extracted by mini-css-extract-plugin
export var quantityInput = "_ll-0";